module.exports = __webpack_public_path__ + "img/border-outer.7d39105e.svg";